"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Slider.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 *
 * @param {object} props
 * @param {number} props.value Current value for the slider
 * @param {(value: number) => void} props.onChange Callback for the slider value change
 * @param {Array<number>} props.breakpoints Array of bullets to display on the slider
 *  At least two breakpoints should be specified to determine the min and max values of the slider
 * @param {number} [props.step] Step of the slider
 * @param {boolean} [props.disabled] Whether the slider is disabled
 * @param {function} props.formatOutput Function to format the slider's value (displayed above the slider active bullet)
 * @returns {React.JSXElement}
 */
var Slider = exports.Slider = function Slider(_ref) {
  var onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 1 : _ref$value,
    disabled = _ref.disabled,
    breakpoints = _ref.breakpoints,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    formatOutput = _ref.formatOutput,
    _ref$hideLabels = _ref.hideLabels,
    hideLabels = _ref$hideLabels === void 0 ? false : _ref$hideLabels,
    _ref$showBreakPoints = _ref.showBreakPoints,
    showBreakPoints = _ref$showBreakPoints === void 0 ? true : _ref$showBreakPoints;
  if (breakpoints.length < 2) {
    throw new Error('Slider must have at least two breakpoints');
  }
  var min = breakpoints[0];
  var max = breakpoints[breakpoints.length - 1];
  var isPercent = max === 100;
  var _useState = (0, _react.useState)(value),
    _useState2 = _slicedToArray(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (typeof value !== 'number') {
      console.warn('Slider value is not a number');
    }
    setInternalValue(parseFloat(value));
  }, [value]);
  var handleSliderChange = (0, _react.useCallback)(function (event) {
    var newValue = parseFloat(event.target.value);
    setInternalValue(newValue);
  }, []);
  var handleSliderInteraction = (0, _react.useCallback)(function (event) {
    var newValue = parseFloat(event.target.value);
    onChange(newValue);
  }, [onChange]);
  (0, _react.useEffect)(function () {
    if (ref.current) {
      ref.current.style.setProperty('--slider-value', (internalValue - min) / (max - min));
    }
  }, [internalValue, min, max]);
  var decimalPlaces = (0, _react.useMemo)(function () {
    var stepValue = step;
    if (typeof stepValue === 'string') {
      stepValue = parseFloat(stepValue);
    }
    if (typeof stepValue === 'number' && stepValue < 1) {
      var stepStr = stepValue.toString();
      var decimalPart = stepStr.split('.')[1];
      return decimalPart ? decimalPart.length : 0;
    }
    return 0;
  }, [step]);
  var convertValueToShow = (0, _react.useCallback)(function (valueToChange) {
    if (formatOutput && typeof formatOutput === 'function') {
      return formatOutput(valueToChange);
    } else {
      return (isPercent ? valueToChange / 100 : valueToChange).toLocaleString(undefined, {
        style: isPercent ? 'percent' : 'decimal',
        minimumFractionDigits: decimalPlaces || 0,
        maximumFractionDigits: decimalPlaces || 2
      });
    }
  }, [formatOutput, isPercent, decimalPlaces]);
  var displayValue = (0, _react.useMemo)(function () {
    return convertValueToShow(internalValue);
  }, [internalValue, convertValueToShow]);
  var maxLabel = (0, _react.useMemo)(function () {
    return convertValueToShow(max);
  }, [convertValueToShow, max]);
  var minLabel = (0, _react.useMemo)(function () {
    return convertValueToShow(min);
  }, [convertValueToShow, min]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "slider-container",
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "range",
    min: min,
    max: max,
    step: step || 1,
    value: internalValue,
    className: "slider",
    onTouchEnd: handleSliderInteraction,
    onMouseUp: handleSliderInteraction,
    onChange: handleSliderChange,
    list: "breakpoints",
    disabled: disabled
  }), !isPercent && !hideLabels && /*#__PURE__*/_react["default"].createElement("div", {
    className: "breakpoints-min-max"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "breakpoint-min"
  }, minLabel !== displayValue ? minLabel : ' '), /*#__PURE__*/_react["default"].createElement("span", {
    className: "breakpoint-min"
  }, maxLabel !== displayValue ? maxLabel : ' ')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "slider-track"
  }), /*#__PURE__*/_react["default"].createElement("datalist", {
    id: "breakpoints",
    className: "slider-breakpoints"
  }, breakpoints.map(function (bp, index) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: bp,
      value: bp,
      className: "".concat(!showBreakPoints && index !== 0 && index !== breakpoints.length - 1 ? 'hide-breakpoint' : '', " ").concat(internalValue >= bp ? 'active' : ''),
      "aria-label": displayValue
    });
  })), /*#__PURE__*/_react["default"].createElement("output", {
    className: "slider-value",
    "aria-label": displayValue
  }, !hideLabels && /*#__PURE__*/_react["default"].createElement("span", null, displayValue)));
};